import { createRouter, createWebHistory } from 'vue-router'
import { cancelAllRequests } from '@/utils/request'
import { useUserInfoStore, useEnvStore } from '@/stores/index'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/home/index.vue'),
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/login/index.vue'),
      meta: {
        title: '登录',
        noToken: true,
      },
    },
    {
      path: '/businessConfirmation',
      name: 'businessConfirmation',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/businessConfirmation.vue'),
      meta: {
        title: '手机号确认',
      },
    },
    {
      path: '/guide',
      name: 'guide',
      component: () => import('@/views/guide.vue'),
      meta: {
        title: '入驻指南',
      },
    },
    {
      path: '/rules',
      name: 'rules',
      component: () => import('@/views/rules.vue'),
      meta: {
        title: '推广规则',
      },
    },
    {
      path: '/certification',
      name: 'certification',
      component: () => import('@/views/certification/index.vue'),
      meta: {
        title: '推广认证',
      },
    },
    {
      path: '/poster',
      name: 'poster',
      component: () => import('@/views/poster.vue'),
      meta: {
        title: '分享购买',
      },
    },
    {
      path: '/settleAccounts-record',
      name: 'settleAccounts-record',
      component: () => import('@/views/settleAccounts/record.vue'),
      meta: {
        title: '结算记录',
      },
    },
    {
      path: '/settleAccounts-details',
      name: 'settleAccounts-details',
      component: () => import('@/views/settleAccounts/details.vue'),
      meta: {
        title: '结算详情',
      },
    },
    {
      path: '/promotion-record',
      name: 'promotion-record',
      component: () => import('@/views/promotion/record.vue'),
      meta: {
        title: '推广记录',
      },
    },
    {
      path: '/myProfile',
      name: 'myProfile',
      component: () => import('@/views/myProfile/index.vue'),
      meta: {
        title: '个人信息',
      },
    },
    {
      path: '/myProfile-info',
      name: 'myProfile-info',
      component: () => import('@/views/myProfile/info/info.vue'),
      meta: {
        title: '个人资料',
      },
    },
    {
      path: '/info-head',
      name: 'info-head',
      component: () => import('@/views/myProfile/info/head.vue'),
      meta: {
        title: '个人头像',
      },
    },
    {
      path: '/edit-mobile',
      name: 'edit-mobile',
      component: () => import('@/views/myProfile/info/editMobile/index.vue'),
      meta: {
        title: '修改手机号',
      },
    },
    {
      path: '/info-bankInfo',
      name: 'info-bankInfo',
      component: () => import('@/views/myProfile/info/bankInfo.vue'),
      meta: {
        title: '银行信息',
      },
    },
    {
      path: '/info-certification',
      name: 'info-certification',
      component: () => import('@/views/myProfile/certification.vue'),
      meta: {
        title: '资格认证',
      },
    },
    {
      path: '/contract',
      name: 'contract',
      component: () => import('@/views/myProfile/contract.vue'),
      meta: {
        title: '合同管理',
      },
    },
    {
      path: '/accountSecurity',
      name: 'accountSecurity',
      component: () => import('@/views/myProfile/accountSecurity.vue'),
      meta: {
        title: '账号安全',
      },
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('@/views/agreement/privacy.vue'),
      meta: {
        title: '隐私协议',
        noToken: true,
      },
    },
    {
      path: '/apply',
      name: 'apply',
      component: () => import('@/views/signContract/apply.vue'),
      meta: {
        title: '申请',
      },
    },
    {
      path: '/sign',
      name: 'sign',
      component: () => import('@/views/signContract/sign.vue'),
      meta: {
        title: '签约',
      },
    },
    {
      path: '/review',
      name: 'review',
      component: () => import('@/views/signContract/review.vue'),
      meta: {
        title: '审核页面',
      },
    },
  ],
})

// ✨将 router 实例挂载到 window，方便 App 优雅控制无刷新跳转
if (typeof window !== 'undefined') {
  window.myAppRouter = router
}

// 全局导航守卫动态修改标题
router.beforeEach(async (to, from, next) => {
  console.log('🚀 ~ from:', from)
  console.log('🚀 ~ to:', to)
  cancelAllRequests()
  const useUserInfo = useUserInfoStore()
  const useEnv = useEnvStore()
  if (!useUserInfo.getInitialized()) {
    // 是否是web环境
    // 如果是login页面或者不执行，不执行initialize
    if (useEnv.getEnv() == 'js') {
      if ((to.path == '/login' && from.path == '/') || to.meta.noToken) {
      } else {
        await useUserInfo.initialize()
      }
    } else {
      // 不是执行
      await useUserInfo.initialize()
    }
  }
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '推广'
  }
  // ------------ 🚨 核心通讯穿透代码 🚨 ------------
  // 定义哪些是绝对的根主页（点击物理返回应该直接退出原生 Webview 回到 App 个人中心）
  const rootPaths = ['/', '/home', '/login']
  const isRootPage = rootPaths.includes(to.path)

  // 只要不是根页面，就代表是多级独立页面（如推广记录、签约申请），需要被 App 安全拦截
  const needAppIntercept = !isRootPage

  // 关键：延迟 80ms 注入异步队列，防止单页应用无刷新切换时通讯通道被原生挂起
  setTimeout(() => {
    if (window.uni && typeof window.uni.postMessage === 'function') {
      window.uni.postMessage({
        data: {
          action: 'updateHistory',
          canBack: needAppIntercept,
          currentPath: to.path
        }
      })
      console.log(`🚀 [H5通讯触发] 成功发送到App -> 路径: ${to.path} | 允许App拦截返回键: ${needAppIntercept}`)
    } else {
      console.error('❌ [H5通讯失败] 未检测到 window.uni 变量，请检查 index.html 引入顺序')
    }
  }, 80)
  // -----------------------------------------------

  next()
})
// H5 端的全局后置守卫
router.afterEach((to) => {
  // 定义哪些是绝对的根入口页面
  const rootPaths = ['/', '/home', '/login']
  const isRootPage = rootPaths.includes(to.path)

  // 兜底逻辑：如果当前不在根页面，或者浏览器的历史堆栈深度大于 1，说明有页面可以回退，通知 App 进行拦截
  // 如果在二级页面返回，就应该拦截并让它执行 history.back() 自动回到 /home
  const h5CanBack = !isRootPage || window.history.length > 1

  if (window.uni && typeof window.uni.postMessage === 'function') {
    // 延迟 50ms 发送，确保 SPA 的 DOM 树和环境上下文切换完毕
    setTimeout(() => {
      window.uni.postMessage({
        data: {
          action: 'updateHistory',
          canBack: h5CanBack,
          currentPath: to.path
        }
      })
      console.log(`====> 【H5上报成功】当前路径: ${to.path}, 允许App拦截物理返回: ${h5CanBack}`)
    }, 50)
  }
})


export default router
